import { useTranslation } from "react-i18next";
import { useCurrentDataContext } from "../../../../../contexts/CurrentDataContext";
import openFile from "../../../../../scripts/openFile";
import classes from "./FormAccomplishmentsUseAttachmentComplete.module.css";

const FormAccomplishmentsUseAttachmentComplete = () => {
  const { t } = useTranslation();

  const { currentData } = useCurrentDataContext();

  const renderAccomplishmentAttachments = () => {
    // Filter records to get list of education and study type attachments
    const attachments =
      currentData?.records &&
      currentData?.records?.filter(
        (record) => record.type === "accomplishment"
      );

    // Render attachment items, showing name of each attachment
    return attachments && attachments?.length > 0
      ? attachments.map((rec, i) => (
          <div
            key={i}
            className={classes.recItemName}
            onClick={() => openFile(rec.file)}
          >
            {rec.title}
          </div>
        ))
      : t("formEducation.noAttachments");
  };

  return (
    <div className={classes.container}>
      <div>{t("formAccomplishmentsUseAttachmentComplete.useAttachments")}</div>

      <div className={classes.attachmentContainer}>
        {renderAccomplishmentAttachments()}
      </div>
    </div>
  );
};

export default FormAccomplishmentsUseAttachmentComplete;
